import { isNil } from "lodash";

export function filterUndefined<T>(arr: (T | undefined)[]) {
  return arr.filter((x): x is T => x !== undefined);
}

export function filterNil<T>(arr: (T | null | undefined)[]) {
  return arr.filter((x): x is T => !isNil(x));
}
